import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetReservations } from "../../shared/services/planning/planning.service";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Scheduler, SchedulerData } from "@bitnoi.se/react-scheduler";
import { ResponsePlanning } from "../../shared/types/response/responseplanning.model";
import { Button, Space, Alert } from "antd";

dayjs.extend(customParseFormat);

const Planning : FC = () => {

    const navigate = useNavigate()

    const {data, isLoading, error} = useGetReservations();

    const [schedulerData, setSchedulerData] = useState<SchedulerData>([]);

    useEffect(() => {
        if(data){
            // Créer un mapping des postes
            const postsMap = new Map<number, ResponsePlanning[]>();
            data.forEach(item => {
                if (!postsMap.has(item.numPoste)) 
                    postsMap.set(item.numPoste, []);
                postsMap.get(item.numPoste)?.push(item);
            });

            // Construire schedulerData
            const rows: SchedulerData = Array.from(postsMap.entries()).map(([poste, items]) => ({
            id: poste.toString(),
            label: {
                title: `Poste ${poste}`,
                subtitle: "",
                icon: "",
            },
            data: items.map(ev => ({
                id: ev.id.toString(),
                startDate: dayjs(`${ev.dateDebut} ${ev.heureDebut}`, "DD/MM/YYYY HH:mm:ss").toDate(),
                endDate: dayjs(`${ev.dateFin} ${ev.heureFin}`, "DD/MM/YYYY HH:mm:ss").toDate(),
                title: ev.nomEvenement || `Réservé`,
                occupancy: dayjs(`${ev.dateFin} ${ev.heureFin}`).diff(dayjs(`${ev.dateDebut} ${ev.heureDebut}`), "minutes"), // durée en minutes
                subtitle: "",
                description: "",
                resourceId: poste.toString(),
            })),
        })).sort((a, b) => Number(a.id) - Number(b.id)); // tri par numéro de poste;
            setSchedulerData(rows);
        }
    }, [data])

    useEffect(() => {
        if(error){
            navigate("/connexion");
        }
    }, [error])

    function retourEspaceUser(){
        navigate("/espaceuser");
    }

    return(
        <Space direction="vertical" size="middle" style={{ display: 'flex', marginTop: "2%" }}>
            <Alert message={<span style={{ fontSize: 16, fontWeight: 700 }}>Information</span>}
                description={
                    <p>Pour modifier la vue du planning, cliquez sur le bouton + ou -</p>
                }
                type="info"
                showIcon
            />
            <div style={{ position : "relative", height: "100vh", width: "100%" }}>
                <Scheduler
                    data={schedulerData}
                    isLoading={isLoading}
                />
            </div>
            <Button type="primary"  onClick={retourEspaceUser} style={{ backgroundColor: "green" }}>Retour</Button>
        </Space>
    );
}

export default Planning;